export default __webpack_public_path__ + "media/images/casatb/contact_us/contact_us_hero-3ee519119d8d6730457a2cfc87fbb580.png";